import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { InputConfig } from '../../../shared/ui/form/input/input.component.config';

function rangoValidator(group: AbstractControl): ValidationErrors | null {
  const desde = group.get('desde').value;
  const hasta = group.get('hasta').value;

  if (!desde || !hasta) {
    return null;
  }

  const inicio = new Date(desde);
  const fin = new Date(hasta);
  inicio.setHours(0, 0, 0, 0);
  fin.setHours(0, 0, 0, 0);

  return inicio <= fin ? null : { rangoInvalido: true };
}

@Component({
    selector: 'app-concept-dialog-sales',
    templateUrl: './concept-dialog-sales.component.html',
    styleUrls: ['./concept-dialog-sales.component.css'],
    standalone: false
})
export class ConceptDialogSalesComponent {

  readonly today = this.startOfDay(new Date());

  readonly form = new FormGroup({
    desde: new FormControl<Date | null>(null, { validators: [Validators.required] }),
    hasta: new FormControl<Date | null>(null, { validators: [Validators.required] }),
  }, { validators: [rangoValidator] });

  readonly desdeConfig: InputConfig = {
    label: 'Desde',
    maxDate: this.today,
    errors: {
      required: 'Indica la fecha de inicio',
      matDatepickerMax: 'No puede ser una fecha futura',
    },
  };

  readonly hastaConfig: InputConfig = {
    label: 'Hasta',
    maxDate: this.today,
    errors: {
      required: 'Indica la fecha de fin',
      matDatepickerMax: 'No puede ser una fecha futura',
      matDatepickerMin: 'Debe ser igual o posterior a \'Desde\'',
    },
  };

  constructor(public dialogRef: MatDialogRef<ConceptDialogSalesComponent>) {
    this.form.controls.desde.valueChanges.subscribe(value => {
      this.hastaConfig.minDate = value || null;
      this.form.controls.hasta.updateValueAndValidity({ emitEvent: false });
    });
  }

  generarExcel(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close({
      desde: this.form.controls.desde.value,
      hasta: this.form.controls.hasta.value,
    });
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  private startOfDay(date: Date): Date {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }
}
